import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuModule } from '@angular/material/menu';
import { MatRipple } from '@angular/material/core';
import { SharedModule } from '../../../modules/shared/shared.module';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ColorPickerComponent } from '../color.picker/color.picker.component';
import { ExpandIndicatorComponent } from '../expand.indicator/expand.indicator.component';

@Component({
  selector: 'ig-text-and-color',
  standalone: true,
  imports: [
    AsyncPipe,
    MatIcon,
    MatMenu,
    MatRipple,
    MatMenuModule,
    SharedModule,
    ColorPickerComponent,
    ExpandIndicatorComponent
  ],
  templateUrl: './text.and.color.component.html',
  styleUrl: './text.and.color.component.scss'
})
export class TextAndColorComponent implements OnInit {
  @Input() item: {text: string, color: string} = {text: '', color: '#fff'};
  @Input() inputMode: 'textarea' | 'input' = 'input';
  @Input() menuClass = '';
  @Input() triggerText = 'Edit text and color';

  @Output() textChange = new EventEmitter<string>();
  @Output() colorSlider = new EventEmitter<string>();
  @Output() close = new EventEmitter<any>();

  form: FormGroup;

  constructor(private _fb: FormBuilder) {
    this.form = this._fb.group({
      text: [null, []],
    });
  }

  onTextChange($event) {
    const value = this.form.get('text').value;
    this.textChange.emit(value);
  }

  onColorSlider($event) {
    this.colorSlider.emit($event);
  }

  ngOnInit(): void {
    this.form.get('text').setValue(this.item.text);
  }
}
